import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewListModule"
const debug = false

export class ViewListModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_LIST, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "List"
        this.description                = "The Task List module provides a comprehensive platform for organizing and managing tasks effectively. With custom grouping, filters, sorting, quick search, and other features, users can tailor the task list to their specific needs, enabling them to organize tasks in a way that best suits their workflow, thus improving productivity and task management efficiency."
        this.svgIcon                    = "isvg-view-list"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-list"
        this.parentSection              = SettingsParentSection.VIEWS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}